import React, { useState } from "react";
import { useOutsideClick } from "./OutsideClick";
import adminImage from "./profile.png";
import useProfileStore from "../../store/useProfileStore";

export const ProfileMenu = ({ children, trigger }) => {
  const [show, setShow] = useState(false);
  const dropRef = useOutsideClick(() => setShow(false));
  return (
    <>
      <div
        className="w-fit relative"
        ref={dropRef}
        onClick={() => setShow((curr) => !curr)}
        style={{ zIndex: 1000 }}
      >
        <div>{trigger}</div>
        {show && (
          <ul 
            className="profile-menu-dropdown min-w-max absolute border border-gray-400 right-0 mt-2 bg-white divide-y divide-gray-200 rounded-lg shadow-xl overflow-hidden"
            style={{ zIndex: 10000 }}
          >
            {children}
          </ul>
        )}
      </div>
    </>
  );
};

export const ProfileMenuItem = ({ children, onClick }) => {
  return (
    <li 
      className=" flex text-lg items-center pl-6 pr-[6rem] py-[15px] gap-4 font-normal text-gray-900 justify-start  hover:bg-gray-100 cursor-pointer"
      onClick={onClick}
    >
      {children}
    </li>
  );
};

export const ProfileIcon = ({ userImage: propUserImage }) => {
  const profileUserImage = useProfileStore((state) => state.profile?.photoURL);
  const userImage = propUserImage || profileUserImage;
  return (
    <img
      className="h-full w-full object-cover rounded-full border border-gray-300 transition-shadow duration-300 ease-in-out hover:shadow-2xl hover:shadow-blue-500/50"
      src={userImage ? (userImage instanceof File ? URL.createObjectURL(userImage) : userImage) : adminImage}
      alt="User Profile"
    />
  );
};
